import React, { useState } from "react";
import Iconify from "../../layouts/components/iconify/iconify";
import "./EditMyTask.scss";
import TodoTest from "./features/todo/TodoTest";
import Comments from "./features/comments/CommentsTest";
import TimeLog from "../timelog/TimeLog";
import TaskDetail from "./features/taskDetail/TaskDetail";
import { useParams } from "react-router-dom";
import { decryptUrlData } from "../../services/CryptoService";
import NewReferenceTask from "./features/taskDetail/feature/referenceTask/NewReferenceTask";
import IconButton from "../../components/ui/iconbutton/IconButton";
import NewReferenceTaskList from "./features/taskDetail/feature/referenceTask/newReferenceTaskList/NewReferenceTaskList";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import TaskTimeLog from "./features/taskDetail/feature/taskTimeLog/TaskTimeLog";
import { useRef } from "react";

const EditMyTask = (props) => {

  const timeLogRef = useRef();
  const taskDetailsRef = useRef();
  const attachedTasksRef = useRef();

  const [activeTab, setActiveTab] = useState("comments");
  const [showPopup, setShowPopup] = useState(false);
  const [isTaskTimeLogOpen, setIsTaskTimeLogOpen] = useState(false);

  const { id } = useParams();
  const taskData = id ? decryptUrlData(id) : null;
  const taskId = taskData.taskId;
  const ProjectId = taskData.projectId;

  const renderContent = () => {
    switch (activeTab) {
      case "comments":
        return <Comments taskId={taskId} ref={taskDetailsRef} projectId={ProjectId} onsuccess={handleSuccess} />;
      case "todo":
        return <TodoTest projectId={ProjectId} taskId={taskId} />;
      case "timelog":
        return <TimeLog taskId={taskId} ref={timeLogRef} projectId={ProjectId} onsuccess={handleSuccess} />;
      case "reference":
        return <NewReferenceTask ref={attachedTasksRef} taskId={taskId} projectId={ProjectId} />;
      default:
        return null;
    }
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleSuccess = () => {
    handleCloseTimelog();
    if (taskDetailsRef.current?.refreshComments) {
      taskDetailsRef.current.refreshComments();
    }
    if (timeLogRef.current?.refreshTimelogs) {
      timeLogRef.current.refreshTimelogs();
    }
    if (attachedTasksRef.current?.refreshAttachedTasks) {
      attachedTasksRef.current.refreshAttachedTasks();
    }
    // setIsSuccess(!isSuccess);
  };

  const handleOpenTimelog = () => {
    setIsTaskTimeLogOpen(true);
  };

  const handleCloseTimelog = () => {
    setIsTaskTimeLogOpen(false);
  };


  return (
    <div className="edit-mytask">
      <div className="mytask-card edit-mytask-left-section">
        <TaskDetail projectId={ProjectId} taskId={taskId} onSuccess={handleSuccess} />{" "}
      </div>
      <div className="mytask-card edit-mytask-middle-section">
        <div className="d-flex justify-content-between">
          <div className="edit-mytask-section-title">
            {activeTab === "comments"
              ? "Comments"
              : activeTab === "todo"
                ? "To Do"
                : activeTab === "timelog"
                  ? "Timelog"
                  : "Reference"}
            <div className="add-action-btn">
              {activeTab === "reference" && (<IconButton size="small" icon="akar-icons:link-chain" shape="square" onClick={handleOpenPopup} />)}
              {activeTab === "timelog" && (<IconButton size="small" icon="zondicons:add-outline" shape="square" onClick={handleOpenTimelog} />)}
            </div>
          </div>
        </div>
        <div className="edit-mytask-section-description">{renderContent()}</div>
      </div>
      <div className="mytask-card edit-mytask-right-section">
        <div className="edit-mytask-toolbar-section">
          <button
            className={`edit-mytask-toolbar-btn ${activeTab === "comments" ? "active" : ""
              }`}
            onClick={() => setActiveTab("comments")}
          >
            <Iconify icon="mdi:comments-outline" />
            <div className="edit-mytask-toolbar-title">Comments</div>
          </button>
          <button
            className={`edit-mytask-toolbar-btn ${activeTab === "todo" ? "active" : ""
              }`}
            onClick={() => setActiveTab("todo")}
          >
            <Iconify icon="lucide:list-todo" />
            <div className="edit-mytask-toolbar-title">To Do</div>
          </button>
          <button
            className={`edit-mytask-toolbar-btn ${activeTab === "timelog" ? "active" : ""
              }`}
            onClick={() => setActiveTab("timelog")}
          >
            <Iconify icon="iconamoon:clock" />
            <div className="edit-mytask-toolbar-title">Timelog</div>
          </button>

          <button
            className={`edit-mytask-toolbar-btn ${activeTab === "reference" ? "active" : ""
              }`}
            onClick={() => setActiveTab("reference")}
          >
            <Iconify icon="akar-icons:link-chain" />
            <div className="edit-mytask-toolbar-title">Reference Tasks</div>
          </button>
        </div>
      </div>
      {showPopup && (
        <CenterModel
          showModal={showPopup}
          className="header-task-center-model attach-task-center-model"
          handleToggleModal={handleClosePopup}
          modalTitle="Attach Task"
          modelSizeClass="w-55"
        >
          <NewReferenceTaskList
            isOpen={showPopup}
            onSuccess={handleSuccess}
            onClose={handleClosePopup}
            projectId={ProjectId}
            taskId={taskId}
          />
        </CenterModel>
      )}
      {isTaskTimeLogOpen && (
        <CenterModel
          showModal={isTaskTimeLogOpen}
          className="header-task-center-model attach-task-center-model  timelog-description-edit"
          modalTitle="Add TimeLog Description"
          handleToggleModal={handleCloseTimelog}
          modelSizeClass="w-40">
          <TaskTimeLog
            taskId={taskId}
            projectId={ProjectId}
            isEdit={false}
            editData={null}
            onSuccess={handleSuccess}
          // onTaskTimeLogSuccess={handleSuccess}
          // ref={timeLogRef}
          />
        </CenterModel>
      )}
    </div>
  );
};

export default EditMyTask;
